import { Route, Routes } from 'react-router-dom';
import Hero from './pages/Hero';
import AdminProjects from './pages/AdminProjects';
import AdminPublications from './pages/AdminPublications';

function App() {
  
  return (
    <Routes>
      <Route path="/" element={<Hero />} />
      <Route path="/admin/projects" element={<AdminProjects />} />
      <Route path="/admin/publications" element={<AdminPublications />} />
    </Routes>
  );
}

export default App;
